<template>
  <el-select
    v-model="activePage"
    placeholder="请选择"
    class="percent-w100"
    @change="changeFunc"
    value-key="url"
  >
    <el-option
      v-for="item in pages"
      :key="item.url"
      :value-key="item.name"
      :label="item.name"
      :value="item"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      /*页面数据*/
      pages: [
        {
          url: "pages/clockIn/index",
          name: "每日打卡",
          type: "页面",
        },
        {
          url: "pagesAnswer/testSite/index",
          name: "考点背诵",
          type: "页面",
        },
        {
          url: "pagesAnswer/answer/sort/list",
          name: "顺序刷题",
          type: "页面",
        },
        {
          url: "pagesAnswer/answer/chaos/list",
          name: "乱序刷题",
          type: "页面",
        },
        {
          url: "pagesAnswer/answer/practice/list",
          name: "专题练习",
          type: "页面",
        },
        {
          url: "pagesAnswer/answer/test/index",
          name: "模拟测试",
          type: "页面",
        },
        {
          url: "pages/myPlan/index",
          name: "我的计划",
          type: "页面",
        }
      ],
      /*选中的值*/
      activePage: "每日打卡",
    };
  },
  created() {
    /*初始化*/
    this.changeFunc(this.pages[0]);
  },
  methods: {
    /*选中的值*/
    changeFunc(e) {
      this.$emit("changeData", e);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Study.vue